// Money and counts the way the catalog page writes them.

const money = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 2 })
const count = new Intl.NumberFormat("en-US")

export const toMoney = (v?: number) => money.format(v ?? 0)

// Per-message and per-minute rates run to three or four places.
export const toRate = (v?: number) => "$" + (v ?? 0).toFixed(4).replace(/0$/, "")

export const toCount = (v?: number) => count.format(v ?? 0)

export const toDate = (v?: string | Date) =>
    v ? new Date(v).toLocaleDateString("en-US", { day: "2-digit", month: "short", year: "numeric" }) : "—"

export const toDateTime = (v?: string | Date) =>
    v ? new Date(v).toLocaleString("en-US", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—"

// An add-on on a plan: part of it, sold beside it, or not offered at all.
export const offerText = (included?: boolean, price?: number) =>
    included ? "Included" : (price ?? 0) > 0 ? "Sold separately" : "Not available"

// A unit price: dollars as money, fractions of a cent (a message, a minute) to four places.
export const toUnit = (v?: number) => (v ?? 0) >= 1 ? toMoney(v) : toRate(v)
